module.exports = __webpack_public_path__ + "img/logo_wcaworld2.70e8b83b.webp";